import React, { useState, useRef, useEffect } from "react";
import inuta from "./assets/inuta/動かしたい.png";
import right from "./assets/inuta/動かしたい2.png";
import left from "./assets/inuta/動かしたい3.png";
import click from "./assets/カチ.mp3";
import "./avatar.css";

function Avatar() {
  const audioContext = useRef(null);

  const ahead = 1; //秒先までスケジューリングする
  let nextNote = 10; //　次に設定するノーツ
  let noteInterval = 1; //ノーツの間隔
  const [intervalIds, setIntervalIds] = useState([]);

  // eslint-disable-next-line
  const [params, setParams] = useState([
    { label: "弾き手", pos: { x: 147, y: 303 } },
    { label: "押え手", pos: { x: 381, y: 306 } },
    { label: "指板上", pos: { x: 416, y: 297 } },
    { label: "指板下", pos: { x: 212, y: 352 } },
  ]);
  const [swingSpeed, setSwingSpeed] = useState(0);
  // eslint-disable-next-line
  const [holdOffset, setHoldOffset] = useState(85);
  let clickBuffer = useRef(null);

  useEffect(() => {
    audioContext.current = new AudioContext();
    setUpAudioBuffer();
  });

  const setUpAudioBuffer = async () => {
    const request = new XMLHttpRequest();
    request.open("GET", click);
    request.responseType = "arraybuffer";
    request.onload = () => {
      audioContext.current
        .decodeAudioData(request.response)
        .then((buffer) => {
          clickBuffer.current = buffer;
        })
        .catch((e) => {
          console.error(e);
        });
    };
    request.send();
  };

  const tik = (time) => {
    const audioSrc = audioContext.current.createBufferSource();
    audioSrc.buffer = clickBuffer.current;
    audioSrc.connect(audioContext.current.destination);
    audioSrc.start(time);
    return;
  };

  const posAdd = (a, b) => {
    return { x: a.x + b.x, y: a.y + b.y };
  };
  const posNeg = (a) => {
    return { x: -1 * a.x, y: -1 * a.y };
  };
  const posMulp = (k, a) => {
    return { x: k * a.x, y: k * a.y };
  };
  const holdStyle = (offset, initial, top, bottom, spm) => {
    let ans = posNeg(initial);
    let min = { x: 0, y: 0 };
    let max = posAdd(top, posNeg(bottom));
    ans = posAdd(ans, posMulp(offset / 100, max));
    ans = posAdd(ans, bottom);
    return {
      marginLeft: `${ans.x}px`,
      marginTop: `${ans.y}px`,
      animation: `${120 / spm}s ease-in-out infinite tiktok`,
    };
  };
  const strumStyle = (offset, spm) => {
    return {
      transformOrigin: `${offset.x}px ${offset.y}px`,
      animation: `${30 / spm}s ease-in-out 1s infinite swing`,
    };
  };
  const baseStyle = (spm) => {
    return {
      transformOrigin: "center bottom",
      animation: `${120 / spm}s ease-in-out 1s infinite swing`,
    };
  };

  const scheduleNote = () => {
    let now = audioContext.current.currentTime;
    while (now + ahead > nextNote) {
      console.log(noteInterval);
      tik(nextNote);
      nextNote += noteInterval;
    }
  };

  const clearSchedulers = (ids) => {
    console.log("clearSchedule", ids);
    ids.forEach((id) => {
      console.log("clear foreach", id);
      clearInterval(id);
    });
  };

  const handleChangeSpeed = async (e) => {
    console.log("handleChangeSpeed");
    await setSwingSpeed(e.target.value);
    console.log(e.target.value);
    if (e.target.value === 0) {
      clearSchedulers(intervalIds);
      return;
    }
    nextNote = audioContext.current.currentTime + 0.2;
    noteInterval = 60 / e.target.value;
    console.log(intervalIds)
    clearSchedulers(intervalIds);
    intervalIds.push(setInterval(scheduleNote, 100));
    console.log("pushed", intervalIds);
  };

  return (
    <div>
      <div class={"h512 over-hidden"}>
        <div className={"relative h512"} style={baseStyle(swingSpeed)}>
          <img
            className={"absolute pointer-none"}
            src={inuta}
            alt="inuta"
          ></img>
          <img
            className={"absolute pointer-none"}
            style={strumStyle(
              params.find((elm) => elm.label === "弾き手").pos,
              swingSpeed
            )}
            src={right}
            alt="hand1"
          ></img>
          <img
            className={"absolute pointer-none"}
            style={holdStyle(
              holdOffset,
              params.find((elm) => elm.label === "押え手").pos,
              params.find((elm) => elm.label === "指板上").pos,
              params.find((elm) => elm.label === "指板下").pos,
              swingSpeed
            )}
            src={left}
            alt="hand2"
          ></img>
        </div>
      </div>
      <div>
        <label>BPM</label>
        <input
          type="number"
          className="input-num no-spin"
          value={swingSpeed}
          onChange={handleChangeSpeed}
          min="0"
          max="300"
        />
      </div>
    </div>
  );
}

export default Avatar;
